/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable no-script-url */

import React from 'react';
import {connect} from 'react-redux';
import {get, map, compact} from 'lodash';
import {I18n} from 'react-redux-i18n';
import Grid from '@material-ui/core/Grid';
import Icon from '@material-ui/core/Icon';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';

import {
  applyFilter,
  updateConstrainedFilters
} from '../libraryFilterActions';
import OerTypeSelector from './OerTypeSelector';
import getSettings from '../../actions/customer';
import {hasAccess} from '../../app/user';

class SummaryMenuFilter extends React.Component {
  state = {
    oerTypeFilter: [],
    groupsFilter: [],
    terminalsFilter: [],
    constrainedFilters: {}
  }

  componentWillReceiveProps(nextProps) {
    const {
      oerTypeFilter,
      groupsFilter,
      terminalsFilter,
      constrainedFilters
    } = nextProps;

    this.setState({
      oerTypeFilter,
      groupsFilter,
      terminalsFilter,
      constrainedFilters
    });
  }

  handleUnreviewedSelection = () => {
    const {constrainedFilters} = this.state;

    const filters = {
      constrainedFilters: {
        ...constrainedFilters,
        unreviewed: true,
        onDemand: false,
        reviewed: false,
        reviewedComplete: false
      }
    };

    this.applyFilter(filters);
  }

  handleReviewedSelection = () => {
    const {constrainedFilters} = this.state;

    const filters = {
      constrainedFilters: {
        ...constrainedFilters,
        reviewed: true,
        onDemand: false,
        unreviewed: false
      }
    };

    this.applyFilter(filters);
  }

  handleReviewedCompleteSelection = () => {
    const {constrainedFilters} = this.state;

    const filters = {
      constrainedFilters: {
        ...constrainedFilters,
        reviewedComplete: true,
        onDemand: false,
        unreviewed: false,
        coachingCompleted: false,
        tagged: false
      }
    };

    this.applyFilter(filters);
  }

  handleCoachingCompleteSelection = () => {
    const {constrainedFilters} = this.state;

    const filters = {
      constrainedFilters: {
        ...constrainedFilters,
        coachingCompleted: true,
        onDemand: false,
        reviewedComplete: false,
        tagged: false
      }
    };

    this.applyFilter(filters);
  }

  handleTaggedSelection = () => {
    const {constrainedFilters} = this.state;

    const filters = {
      constrainedFilters: {
        ...constrainedFilters,
        tagged: true,
        onDemand: false,
        reviewedComplete: false,
        coachingCompleted: false
      }
    };

    this.applyFilter(filters);
  }

  handleOnDemandSelection = () => {
    const {constrainedFilters} = this.state;

    const filters = {
      constrainedFilters: {
        ...constrainedFilters,
        onDemand: true,
        reviewed: false,
        reviewedComplete: false,
        unreviewed: false,
        coachingCompleted: false,
        flagged: false,
        tagged: false
      }
    };

    this.applyFilter(filters);
  }

  handleLockedVideoSelection = () => {
    const {constrainedFilters} = this.state;

    const filters = {
      constrainedFilters: {
        ...constrainedFilters,
        locked: true
      }
    };

    this.applyFilter(filters);
  }


  applyFilter = filters => {
    const {chipsFilter, currentFilters} = this.props;

    const {
      oerTypeFilter,
      constrainedFilters,
      groupsFilter,
      terminalsFilter
    } = this.state;

    this.props.applyFilter({
      ...currentFilters,
      constrainedFilters,
      oerTypeFilter,
      groupsFilter,
      terminalsFilter,
      chipsFilter,
      ...filters
    });

    this.props.updateConstrainedFilters(constrainedFilters);
  }

  renderOerTypesSummary = () => {
    const {summary, customer} = this.props;
    const oerBuckets = get(summary, 'oer.buckets', null);

    const oerTypesSummary = map(oerBuckets, bucket => {
      const docCount = get(bucket, 'efetch.doc_count', bucket.doc_count);
      if (docCount) {
        return (
          <OerTypeSelector
            key={bucket.key}
            bucket={bucket}
            customer={customer}
            constrainedFilters={this.state.constrainedFilters}
            summary={summary}
            updateConstrainedFilters={this.props.updateConstrainedFilters}
            applyFilter={this.applyFilter}
          />
        );
      }
      return null;
    });

    if (compact(oerTypesSummary).length === 0) {
      return null;
    }

    return (
      <List>
        <ListItem className="summarycolumn__title">{I18n.t('filter.oer.summaryLabel')}</ListItem>
        {oerTypesSummary}
      </List>
    );
  }

  renderUnReviewed = () => {
    const {summary, libraryTotalCount} = this.props;
    const reviewsCount = get(summary, 'review.doc_count', 0);

    const unReviewedTotal = libraryTotalCount - reviewsCount;

    return (
      <ListItem className="summarycolumn__oertype-item" button>
        <ListItemText
          onClick={this.handleUnreviewedSelection}
          primary={I18n.t('filter.reviews.unReviewed')}
        />
        <span className="summarycolumn__oertype-count">{unReviewedTotal}</span>
      </ListItem>
    );
  }

  renderReviewed = () => {
    const {summary} = this.props;
    const reviewsCount = get(summary, 'review.doc_count', 0);

    return (
      <ListItem className="summarycolumn__oertype-item" button>
        <ListItemText
          onClick={this.handleReviewedSelection}
          primary={I18n.t('filter.reviews.reviewed')}
        />
        <span className="summarycolumn__oertype-count">{reviewsCount}</span>
      </ListItem>
    );
  }

  renderReviewedComplete = () => {
    const {summary} = this.props;
    const reviewCompletedBuckets = get(summary, 'reviewCompleted.buckets', []);
    const reviewCompletedBucket = reviewCompletedBuckets.find(b => b.key_as_string === 'true');
    const reviewCompletedTotal = get(reviewCompletedBucket, 'doc_count', 0);

    return (
      <ListItem className="summarycolumn__oertype-item" button>
        <ListItemText
          onClick={this.handleReviewedCompleteSelection}
          primary={I18n.t('filter.reviews.reviewedComplete')}
        />
        <span className="summarycolumn__oertype-count">{reviewCompletedTotal}</span>
      </ListItem>
    );
  }

  renderCoachingComplete = () => {
    const {summary} = this.props;
    const coachBuckets = get(summary, 'coachCompleted.buckets', []);
    const coachedCompletedBucket = coachBuckets.find(b => b.key === 1);
    const coachedCompletedTotal = get(coachedCompletedBucket, 'doc_count', 0);

    return (
      <ListItem className="summarycolumn__oertype-item" button>
        <ListItemText
          onClick={this.handleCoachingCompleteSelection}
          primary={I18n.t('filter.reviews.coachingComplete')}
        />
        <span className="summarycolumn__oertype-count">{coachedCompletedTotal}</span>
      </ListItem>
    );
  }

  renderTaggedReviews = () => {
    const {summary} = this.props;
    const taggedReviewsBuckets = get(summary, 'taggedReview.buckets', []);
    const taggedReviewsBucket = taggedReviewsBuckets.find(b => b.key === 1);
    const taggedReviewsTotal = get(taggedReviewsBucket, 'doc_count', 0);

    return (
      <ListItem className="summarycolumn__oertype-item" button>
        <ListItemText
          onClick={this.handleTaggedSelection}
          primary={I18n.t('filter.reviews.tagged')}
        />
        <span className="summarycolumn__oertype-count">{taggedReviewsTotal}</span>
      </ListItem>
    );
  }

  renderReviewsSummary = () => {
    return (
      <List>
        <ListItem className="summarycolumn__title">{I18n.t('filter.reviews.label')}</ListItem>

        {this.renderUnReviewed()}
        {this.renderReviewed()}
        {this.renderReviewedComplete()}
        {this.renderCoachingComplete()}
        {this.renderTaggedReviews()}
      </List>
    );
  }

  renderLockedVideoSummary = () => {
    const {summary} = this.props;
    const triggerTypeBuckets = get(summary, 'lockedStatus.buckets', []);
    const onDemandBucket = triggerTypeBuckets.find(b => b.key_as_string === 'true');
    const lockedTotal = get(onDemandBucket, 'doc_count', 0);

    if (lockedTotal > 0) {
      return (
        <List>
          <ListItem className="summarycolumn__title">{I18n.t('filter.summaryMenu.adminOnly')}</ListItem>

          <ListItem className="summarycolumn__oertype-item" button>
            <ListItemText
              onClick={this.handleLockedVideoSelection}
              primary={I18n.t('filter.locked')}
            />
            <span className="summarycolumn__oertype-count">{lockedTotal}</span>
          </ListItem>
        </List>
      );
    }

    return null;
  }

  renderOnDemandSummary = () => {
    const {summary} = this.props;
    const triggerTypeBuckets = get(summary, 'triggerType.buckets', []);
    const onDemandBucket = triggerTypeBuckets.find(b => b.key === 'ondemand');
    const onDemandTotal = get(onDemandBucket, 'doc_count', 0);

    if (onDemandTotal > 0) {
      return (
        <List>
          <ListItem className="summarycolumn__title">{I18n.t('filter.summaryMenu.requestedVideos')}</ListItem>

          <ListItem className="summarycolumn__oertype-item" button>
            <ListItemText
              onClick={this.handleOnDemandSelection}
              primary={I18n.t('filter.onDemand')}
            />
            <span className="summarycolumn__oertype-count">{onDemandTotal}</span>
          </ListItem>
        </List>
      );
    }

    return null;
  }

  render() {
    if (this.props.isMobile) {
      return null;
    }
    const {isAdmin} = this.props;

    return (
      <React.Fragment>
        <a
          href="javascript:;"
          className="summarycolumn__chevron"
          onClick={this.props.handleSummaryClick}
        >
          <Icon className="summarycolumn__chevron-icon">chevron_right</Icon>
        </a>

        <Grid item md={2} className="summarycolumn">
          <div className="summarycolumn__content">
            <div className="summarycolumn__content-overflow">
              {this.renderOerTypesSummary()}
              {isAdmin && this.renderLockedVideoSummary()}
              {this.renderReviewsSummary()}
              {this.renderOnDemandSummary()}
            </div>
          </div>
        </Grid>
      </React.Fragment>
    );
  }
}

function mapStateToProps(state) {
  const {libraryFilters} = state;
  const isAdmin = hasAccess([
    'videoIntelligenceAdmin',
    'changeCustomer',
    'videoIntelligenceInternal'
  ]);
  const oerTypeFilter = get(libraryFilters, 'selectedFilters.oerTypeFilter');
  const groupsFilter = get(libraryFilters, 'selectedFilters.groupsFilter');
  const terminalsFilter = get(libraryFilters, 'selectedFilters.terminalsFilter');
  const constrainedFilters = get(libraryFilters, 'selectedFilters.constrainedFilters');
  const chipsFilter = get(libraryFilters, 'selectedFilters.chipsFilter');

  return {
    ...state.i18n.locale,
    customer: state.customer,
    currentFilters: libraryFilters.filters,
    oerTypeFilter,
    groupsFilter,
    terminalsFilter,
    constrainedFilters,
    isAdmin,
    chipsFilter
  };
}

export default connect(mapStateToProps, {
  applyFilter,
  updateConstrainedFilters,
  getSettings
})(SummaryMenuFilter);
